export default __webpack_public_path__ + "static/media/Thumb_Shoes_01.e2a6f538.png";